import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextInput as MantineTextInput, } from '@mantine/core';
import { cn } from '@monorepo/utils';
const TextInput = React.forwardRef(({ size = 'md', ...props }, ref) => {
    const classNames = props.classNames;
    return (_jsx(MantineTextInput, { ref: ref, size: size, autoComplete: "nope", ...props, classNames: {
            ...classNames,
            input: cn('border border-gray-300 text-gray-900 text-sm placeholder:font-normal ', classNames?.input),
            error: cn('text-sm', classNames?.error),
        } }));
});
TextInput.displayName = 'TextInput';
export default TextInput;
